import { render, staticRenderFns } from "./TablePagination.vue?vue&type=template&id=35101964&scoped=true&"
import script from "./TablePagination.vue?vue&type=script&lang=js&"
export * from "./TablePagination.vue?vue&type=script&lang=js&"
import style0 from "./TablePagination.vue?vue&type=style&index=0&id=35101964&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35101964",
  null
  
)

export default component.exports